module.exports = __webpack_public_path__ + "f73f504aba94a7c0c78530619b767092.png";